import { Tabs } from '@radix-ui/react-tabs';
import { TabsList, TabsTrigger } from '../_lib/ClickableTab';

interface Option {
  label: string;
  value: string | number;
  [key: string]: string | number; 
}

interface RadioButtonProps {
  id?: string;
  className?: string;
  value: string | number;
  options: Option[];
  choose?: string;
  onChange?: (value: string | number) => void;
  buttonSize?: 'xs' | 'sm' | 'lg' | 'cols-2';
  // Add form registration props
  name?: string;
  onBlur?: () => void;
  ref?: React.Ref<any>;
}

function getTriggerSize(size: RadioButtonProps['buttonSize']) {
  switch (size) {
    case 'xs':
      return '!py-0.5 !h-fit !px-1';
    default:
      return '';
  }
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id = 'input-form-control',
  className = '',
  value,
  options = [],
  choose = 'value',
  onChange,
  buttonSize = 'lg',
  name,
  onBlur,
  ref,
  ...props
}) => {
  const handleClick = (val: string | number) => {
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <Tabs
      id={id}
      defaultValue={String(value)}
      className={`inline-flex h-fit w-fit items-center justify-center gap-1 ${className}`}
      {...props}
    >
      <TabsList className="flex !gap-0 rounded-[8px] !border-2 !border-[#D7D7D7] !py-0 !px-0">
        {options?.map((itm, index) => (
          <TabsTrigger
            key={`${index}-${itm[choose as keyof Option]}`}
            value={String(itm[choose as keyof Option])}
            onClick={() => handleClick(itm[choose as keyof Option])}
            className={`${getTriggerSize(buttonSize)} !mx-0 font-inter !font-medium  ${
              index !== options.length - 1 ? 'border-r-2 border-gray-100' : ''
            } focus-visible:ring-ring inline-flex h-full w-full items-center justify-center whitespace-nowrap p-3  text-sm   font-semibold ring-offset-white transition-all hover:bg-primary-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-[#F4F7FE] data-[state=inactive]:bg-white data-[state=active]:text-[#039BE5] data-[state=inactive]:text-[#667085] data-[state=active]:shadow-sm ${
              index === 0 ? '!rounded-l-[6px]' : ''
            } ${index === options.length - 1 ? '!rounded-r-[6px]' : ''}`}
          >
            {itm.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default RadioButton;